import React, { useContext } from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import FormControl from "@material-ui/core/FormControl"
import Button from "@material-ui/core/Button"
import Typography from "@material-ui/core/Typography"
import ViewComfyIcon from "@material-ui/icons/ViewComfy"
import UploadFileButton from "./UploadFileButton"
import DownloadFileButton from "./DownloadFileButton"
import Grid from "@material-ui/core/Grid"
import { UserContext } from "../contexts/UserContext"

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    spacing: 3,
    marginBottom: 50,
  },
  downloadButton: {
    margin: 0,
    position: "relative",
    width: 300,
  },
  title: {
    fontSize: 20,
    textTransform: "uppercase",
  },
  detail: {
    fontSize: 12,
    fontStyle: "italic",
  },
  formControl: {
    margin: theme.spacing(1),
    marginBottom: 0,
    minWidth: 300,
    marginTop: 50,
  },
  formControlLower: {
    margin: theme.spacing(1),
    minWidth: 300,
    marginTop: 10,
  },
  uploadBtn: {
    position: "absolute",
    right: 10,
    top: 10,
  },
  button: {
    minWidth: 300,
  },
  content: {
    display: "flex",
  },
  tableButton: {
    minWidth: 300,
    color: "white",
    backgroundColor: "#675dc6",
    borderColor: "#675dc6",
    "&:hover": {
      backgroundColor: "#3c3673",
      borderColor: "#0062cc",
      boxShadow: "none",
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: "#3c3673",
      borderColor: "#0062cc",
    },
    "&:focus": {
      boxShadow: "none",
      outline: "none !important",
    },
  },
}))

const MenuCard = ({ options, title, onSelect, uploads, downloads }) => {
  const classes = useStyles()

  const { user } = useContext(UserContext)

  const mapEditable = (editableNum) => {
    if (editableNum === 1) {
      return ["READ"]
    } else if (editableNum === 2) {
      return ["READ", "USER"]
    } else if (editableNum === 3) {
      return ["READ", "USER", "ADMIN"]
    } else {
      return []
    }
  }

  const { accessLevel } = user
  const isAdmin = accessLevel === "ADMIN"

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent className="container">
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="left"
          justify="center"
        >
          <Typography className={classes.title} color="textSecondary" gutterBottom>
            {title}
          </Typography>
          {options &&
            options.map((option) => (
              <CardActions key={option.id}>
                {option.label === "Readers Per Copy" && isAdmin && (
                  <Button
                    className={classes.tableButton}
                    variant="contained"
                    startIcon={<ViewComfyIcon />}
                    onClick={() =>
                      onSelect({
                        label: option.label,
                        value: option.folder_name,
                        editable: mapEditable(option.edit_permission_type_id),
                      })
                    }
                    disableElevation
                  >
                    {option.label}
                  </Button>
                )}
                {option.label !== "Readers Per Copy" && (
                  <Button
                    className={classes.tableButton}
                    variant="contained"
                    startIcon={<ViewComfyIcon />}
                    onClick={() =>
                      onSelect({
                        label: option.label,
                        value: option.folder_name,
                        editable: mapEditable(option.edit_permission_type_id),
                      })
                    }
                    disableElevation
                  >
                    {option.label}
                  </Button>
                )}
                {option.updated && (
                  <Typography
                    className={classes.detail}
                    color="textSecondary"
                    gutterBottom
                  >
                    Updated test by test
                  </Typography>
                )}
              </CardActions>
            ))}
          <FormControl className={classes.formControl}>
            {uploads &&
              uploads.map((upload) => (
                <UploadFileButton
                  key={upload.id}
                  disabled={false}
                  label={upload.label}
                  fileName={upload.folder_name}
                  saveActivity={upload.saveActivity}
                  inline={false}
                  context={upload.folder_name}
                />
              ))}
          </FormControl>
          <FormControl>
            {downloads &&
              downloads.map((download) => (
                <DownloadFileButton
                  key={download.id}
                  disabled={false}
                  label={download.label}
                  fileName={download.folder_name}
                  context={download.folder_name}
                  className={classes.downloadButton}
                  width={300}
                />
              ))}
          </FormControl>
        </Grid>
      </CardContent>
    </Card>
  )
}

MenuCard.propTypes = {
  options: PropTypes.object,
  title: PropTypes.string,
  onSelect: PropTypes.func,
  saveActivity: PropTypes.func,
  uploads: PropTypes.array,
  downloads: PropTypes.array,
  uploadsDownloads: PropTypes.array,
}

export default MenuCard
